import { Injectable } from '@angular/core';
import { BaseServiceService } from '../base_service/base-service.service';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import { Observable,Subject  } from 'rxjs';
import { formatDate } from '@angular/common';
import { StorageServicesService } from '../../services/storage_services/storage-services.service';


@Injectable({
  providedIn: 'root'
})
export class CommonServiceService {

  URL: string
 parat: string;

  constructor(
    private baseService: BaseServiceService, 
    private http: HttpClient,
    private storageService: StorageServicesService,
    ) {
    this.URL = this.baseService.baseUrl();
   }

  // get Rules
  getRules(): Observable<any>{
    const url_rules = this.URL + 'rules/getRules';
    return this.http.get(url_rules);
  }

  // get Rule Item
  getRuleItem(para): Observable<any>{
  const data = {id: para};
  const url_rulesItems = this.URL + 'rules/getRuleItems';
  return this.http.get(url_rulesItems , {params: data});
  }

  // get latest version
  getVersion(): Observable<any>{
  //const data = {id: para};
  const url_rulesItems = this.URL + 'customer/getLatestAppVersion';
  return this.http.get(url_rulesItems , {});
  }

  // get Racing Paper
  getRacingPaper(): Observable<any>{
    const url_racingPaper = this.URL + 'meeting/getRacingPaper';
    return this.http.get(url_racingPaper);
  }

  // get current Data and time
  getCurrentDateTime(){
    return  formatDate(new Date(), 'dd/MM/y h:mm:ss', 'en');
  }

  // trim event time
  trimEventTime(time : string){
    return time.substr(0, time.length - 3); 
  }

  getaccountNo() {
    var loginDataSessionString = JSON.parse(this.storageService.getLocal("accountNo")) ;
    return loginDataSessionString;
  }

  getToken() {
    var tokenDataSession = JSON.parse(this.storageService.getLocal("token"));
    return tokenDataSession;
  }


  //refresh race detail page when remove all from bet slip modal
  private subject = new Subject<any>();
  sendClickEvent() {
    this.subject.next();
  }
  getClickEvent(): Observable<any> {
    return this.subject.asObservable();
  }

  getServerTime(){
    const url = this.URL + 'meeting/ping';
    return this.http.get(url);
  }


}
